import { Grid, Typography } from '@mui/material';
import React from 'react';
interface PageHeaderProps {
    title: string;
    children?: any;
}
const PageHeader: React.FC<PageHeaderProps> = ({title, children}) => {
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
      </Grid>
      {children && React.Children.map(children, (child) => React.cloneElement(child))}
    </Grid>
  );
};

export default PageHeader;
